// src/components/Header.tsx

import { NavLink } from "react-router-dom";
import AppNameAsLogo from "../AskTheBil";

const Header = () => {
  return (
    <header className="fixed top-0 left-0 right-0 bg-white shadow-sm z-50">
      <div className="max-w-7xl mx-auto px-4 h-16 flex items-center justify-between">
        <div className="flex items-center gap-4">
          <img className="h-8 w-8" src="./bg-1.jpeg" alt="Ask The Bill" />
          <AppNameAsLogo />
        </div>
        <div className="flex items-center gap-4">
          <NavLink
            to="/about"
            className="text-md font-medium text-gray-700 hover:text-gray-900 transition-colors duration-200 hover:border-b-2 hover:border-gray-900"
          >
            About
          </NavLink>
        </div>
      </div>
    </header>
  );
};

export default Header;
